"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneAuthValidateSmsViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _PhoneAuthValidateSmsViewContainer = require("./PhoneAuthValidateSmsViewContainer");
const PhoneAuthValidateSmsViewContainer = exports.PhoneAuthValidateSmsViewContainer = (0, _SourceProvider.SourceProvider)(_PhoneAuthValidateSmsViewContainer.PhoneAuthValidateSmsViewContainer);